module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/jenny-brumfield-baa90400aad58ad2845a86d5cca30770.jpg";